import { createAPIActionEntity } from "../../actions/actionUtils.js";

export const ACCOUNT = {
  ...createAPIActionEntity("ACCOUNT"),
  SET_TIMEZONE: "ACCOUNT_SET_TIMEZONE"
};
